import React from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import Layout from '@fuww/library/src/Layout';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import loading from '../lib/loading';
import getRedirectJob from '../lib/getRedirectJob';

const JobDetail = dynamic(() => import(
  '../components/Jobs/JobDetail'
), {
  loading,
  ssr: true,
});

export const CareersJobPage = () => {
  const { query: { id } } = useRouter();
  const { jobsLocale } = useSiteContext();

  return <JobDetail locale={jobsLocale} id={Number(id)} />;
};

CareersJobPage.getInitialProps = getRedirectJob('careers-job');

CareersJobPage.getLayout = (page: React.ReactNode) => (
  <Layout layoutMaxWidth="100vw">{page}</Layout>
);

export default withApollo(CareersJobPage);
